var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHousing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3643 1.60627C12.4115 1.60051 12.4585 1.59885 12.505 1.601C12.5483 1.59952 12.5919 1.60133 12.6357 1.60667C17.2282 2.16669 25.4679 9.71261 24.4066 12.368L24.3925 12.4037C24.3551 12.4987 24.3171 12.5953 24.2495 12.6712C23.9988 12.9526 23.2265 13.1566 22.1 13.3006V20.9094C22.1 21.7329 21.4324 22.4005 20.6089 22.4005H4.39114C3.5676 22.4005 2.9 21.7329 2.9 20.9094V13.3002C1.77349 13.1562 1.00116 12.9522 0.750452 12.6708C0.682874 12.5949 0.64488 12.4983 0.607484 12.4033L0.593381 12.3676C-0.467886 9.71221 7.77178 2.16629 12.3643 1.60627Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 22.4005H8.5V16.2643C8.5 15.2349 9.33451 14.4004 10.3639 14.4004H14.6361C15.6655 14.4004 16.5 15.2349 16.5 16.2643V22.4005Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHousing);
export default __webpack_public_path__ + "static/media/iconHousing.c4977cea3327c797ae08ca0845cb68c4.svg";
export { ForwardRef as ReactComponent };